import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Globe, Calendar } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

type Props = {
  stats: {
    total: number;
    countriesCount: number;
    recent: number;
  };
};

export const OrganizersStats = ({ stats }: Props) => {
  const { translations } = useLanguage();

  const statsItems = [
    {
      title: translations?.organizersStats?.total || 'Total Organizers',
      value: stats.total,
      icon: Building2,
      color: 'primary',
    },
    {
      title: translations?.organizersStats?.countries || 'Countries',
      value: stats.countriesCount,
      icon: Globe,
      color: 'blue',
    },
    {
      title: translations?.organizersStats?.recent || 'Recent (30 days)',
      value: stats.recent,
      icon: Calendar,
      color: 'green',
    },
  ];

  // Color classes mapping
  const colorClasses = {
    primary: {
      bg: 'bg-primary-50',
      ring: 'ring-primary-500/20',
      text: 'text-primary-600',
    },
    blue: {
      bg: 'bg-blue-50',
      ring: 'ring-blue-500/20',
      text: 'text-blue-600',
    },
    green: {
      bg: 'bg-green-50',
      ring: 'ring-green-500/20',
      text: 'text-green-600',
    },
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {statsItems.map((item, index) => (
        <motion.div
          key={item.title}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className={`bg-white p-4 md:p-6 rounded-xl shadow-sm ring-1 ring-inset ${colorClasses[item.color as keyof typeof colorClasses].ring}`}
        >
          <div className="flex items-center gap-4">
            <div className={`p-3 rounded-lg ${colorClasses[item.color as keyof typeof colorClasses].bg}`}>
              <item.icon className={colorClasses[item.color as keyof typeof colorClasses].text} size={24} />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-500">{item.title}</p>
              <p className={`text-2xl font-bold mt-1 ${colorClasses[item.color as keyof typeof colorClasses].text}`}>
                {item.value}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};